import React, { Component, PropTypes } from 'react';
import './ErrorField.css';


class ErrorField extends Component {
  render() {
    const { error, hasBlurred, multiError } = this.props;
    return (
      <div>
        {
          error && !multiError && hasBlurred &&
          <p className="input-field__error">{error}</p>
        }
        {
          error && multiError && hasBlurred &&
          <ul className='error__wrap'>
            <li className='error__prompt'>{error.prompt}</li>
            {
              multiError.errors.map((err, index) => {
                let classStyle = 'error__invalid';
                if (err.valid) classStyle = 'error__valid'
                return (
                  <li className={classStyle} key={index}>
                    { err.valid && <img src='/images/checked.svg' className="error__checked" alt="alt"/> }
                    { !err.valid && <img src='/images/x-mark.svg' className="error__checked" alt="alt"/> }
                    {err.requirement}
                  </li>
                )
              })
            }
          </ul>
        }
      </div>
    );
  }
}

ErrorField.propTypes = {
  error: PropTypes.string,
  multiError: PropTypes.Array,
  hasBlurred: PropTypes.bool.isRequired
};

export default ErrorField;



/** WEBPACK FOOTER **
 ** ./src/components/ErrorField/index.js
 **/